import type { PropsWithChildren } from 'react'

import { Divider } from '../../divider/divider.tsx'

export const FocusedLayoutHeader = ({ children }: PropsWithChildren) => {
  return (
    <header className="shrink-0 flex flex-col items-center gap-8">
      {children}
      <Divider className="w-100 h-px" />
    </header>
  )
}
